<template>
  <section class="messanger-info-section">
    <b-container class="h-100">
      <b-row class="h-100 align-content-center">
        <b-col sm="12" md="4" lg="4">
          <div class="card-messanger-box">
            <div class="icon-container">
              <img class="icon" src="../../assets/img/messenger/messages-icon.svg" alt="Icon">
            </div>
            <div class="card-messanger-text">
              <h3 class="card-title">{{$t('messages')}}</h3>
              <p class="card-subtitle">{{$t('communicate_with_friends_in_private_messages')}}</p>
            </div>
            <div class="card-messanger-img">
              <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/messenger/social-messages-eng.png" alt="Messenger image">
              <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/messenger/social-messages-ua.png" alt="Messenger image">
              <img v-else class="main-photo" src="../../assets/img/messenger/social-messages-eng.png" alt="Messenger banner image">
            </div>
          </div>
        </b-col>
        <b-col sm="12" md="4" lg="4">
          <div class="card-messanger-box">
            <div class="icon-container">
              <img class="icon" src="../../assets/img/messenger/friends.svg" alt="Icon">
            </div>
            <div class="card-messanger-text">
              <h3 class="card-title">{{$t('friends')}}</h3>
              <p class="card-subtitle">{{$t('find_your_friends_meet_new_people_and_add_them_to_your_friends_list')}}</p>
            </div>
            <div class="card-messanger-img">
              <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/messenger/friends-img-eng.png" alt="Friends image">
              <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/messenger/friends-img-ua.png" alt="Friends image">
              <img v-else class="main-photo" src="../../assets/img/messenger/friends-img-eng.png" alt="Friends banner image">
            </div>
          </div>
        </b-col>
        <b-col sm="12" md="4" lg="4">
          <div class="card-messanger-box">
            <div class="icon-container">
              <img class="icon" src="../../assets/img/messenger/world.svg" alt="Icon">
            </div>
            <div class="card-messanger-text">
              <h3 class="card-title">{{$t('people')}}</h3>
              <p class="card-subtitle">{{$t('be_in_touch_with_dog_lovers_from_all_over_the_world')}}</p>
            </div>
            <div class="card-messanger-img">
              <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/messenger/social-friens-request-eng.png" alt="Friends image">
              <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/messenger/social-friens-request-ua.png" alt="Friends image">
              <img v-else class="main-photo" src="../../assets/img/messenger/social-friens-request-eng.png" alt="Friends banner image">
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/app";

.messanger-info-section {
  padding-top: 80px;
  padding-bottom: 80px;

  .card-messanger-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    text-align: center;
    margin-bottom: 40px;
    .icon-container{
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 120px;
        height: 120px;
      }
    }
    .card-messanger-text{
      font-family: $main-font;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      gap: 16px;
      color: #30394B;
      .card-title{
        font-size: 24px;
        font-weight: 700;
        line-height: 28.8px;
        text-align: center;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 20px;
          line-height: 120%;
        }
        @media screen and (min-width: 768px) {
          font-size: 24px;
          line-height: 28.8px;
        }
        &:first-letter{
          text-transform: uppercase;
        }
      }
      .card-subtitle{
        width: 100%;
        max-width: 286px;
        min-height: 78px;
        font-size: 18px;
        font-weight: 300;
        line-height: 25.2px;
        text-align: center;
        margin: 0 auto;
        margin-bottom: 0;
        @media screen and (min-width: 320px) {
          font-size: 16px;
          line-height: 140%;
          min-height: unset;
        }
        @media screen and (min-width: 768px) {
          min-height: 78px;
          font-size: 16px;
          line-height: 140%;
        }
        @media screen and (min-width: 992px) {
          font-size: 18px;
          font-weight: 300;
          line-height: 25.2px;
        }
      }
    }
    .card-messanger-img {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img{
        @media screen and (min-width: 320px) {
          width: 100%;
        }
      }
    }
  }
}
</style>
